import style from './button.module.css';

export const Button = ({ text, type, icon }) => {
  return (
    <>
      {type ? (
        <button className={style.button}>
          {icon ? <span className={style.icon}>{icon}</span> : text}
        </button>
      ) : (
        <button className={style.button2}>
          {icon ? <span className={style.icon}>{icon}</span> : text}
        </button>
      )}
    </>
  );
};
